import { P as Popover, d as defineCustomElement$1 } from './p-106f8152.js';
const OwcPopover = Popover;
const defineCustomElement = defineCustomElement$1;
export { OwcPopover, defineCustomElement };